import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const { classNames } = Mobi2Go.helpers;

const AddressUnavailableMessage = ({ show, emphasis }) => {
    const { t } = useTranslation('customer.address.map-polygons');

    return (
        <div
            className={classNames(
                'm2g-customer-address-message',
                'm2g-customer-address-message--address-unavailable',
                {
                    'm2g-customer-address-message--hidden': !show,
                    'm2g-customer-address-message--emphasis': emphasis,
                }
            )}
        >
            <div className="m2g-customer-address-message-icon m2g-icon m2g-icon--alert" />
            <div className="m2g-customer-address-message-content">
                <strong className="m2g-customer-address-message-content-title">
                    {t('delivery_unavailable')}
                </strong>
                <br />
                <div className="m2g-customer-address-message-content-message">
                    {t('address_outside_delivery_area')}
                </div>
            </div>
            <div className="m2g-customer-address-message-arrow-icon m2g-icon m2g-icon--up" />
        </div>
    );
};

AddressUnavailableMessage.propTypes = {
    show: PropTypes.bool.isRequired,
    emphasis: PropTypes.bool.isRequired,
};

export default AddressUnavailableMessage;
